import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SolicitacaoDTO } from "../dto/solicitacao";
import { PadraoService } from 'src/app/service/padrao/padrao.service';
import { MatDialog } from '@angular/material/dialog';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-confirmacao-solicitacao-dialog',
  templateUrl: './confirmacao-solicitacao-dialog.component.html',
  styleUrls: ['./confirmacao-solicitacao-dialog.component.css'],
  providers: [PadraoService, MatDialog],
})
export class ConfirmacaoSolicitacaoDialogComponent implements OnInit {

  @BlockUI() loading: NgBlockUI;

  constructor(public dialogRef: MatDialogRef<ConfirmacaoSolicitacaoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private padraoService: PadraoService, private dialog: MatDialog) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    this.loading.start('Aguarde um momento...');
    this.padraoService.salvarSolicitacao(this.data.formData).subscribe(response => {
      this.loading.stop();
      this.dialogRef.close(response);
    }, (error) => {
      this.loading.stop();
      this.dialogRef.close(error);
    });
  }

  

}
